type ScoreRange = "all" | "90+" | "80-89" | "60-79" | "<60";

export function matchesScoreRange(score: number, range: ScoreRange): boolean {
  if (range === "all") return true;
  if (range === "90+") return score >= 90;
  if (range === "80-89") return score >= 80 && score < 90;
  if (range === "60-79") return score >= 60 && score < 80;
  return score < 60;
}
